import React from 'react'
import type { UserSelectProps } from '../User/UserSelect/UserSelect'
import { UserSelect } from '../User/UserSelect/UserSelect'
import { gql } from '@apollo/client'

const collaboratorsQuery = gql`
  query getCollaboratorUsers($filter: JSON!, $options: JSON) {
    getCollaboratorUsers(filter: $filter, options: $options) {
      _id
      profile {
        _id
        name
        email
        picture
      }
      status
      company {
        _id
        name
        domain
      }
    }
  }
`

// The server-side collaborator search this component and `AssigneeSelect` (chat.webui) both
// need — filters the tenant's collaborator-company users, never on the client.
export const getCollaboratorUsersDataLoadOptions = (filter = {}) => ({
  query: collaboratorsQuery,
  filter: ({ input }) => {
    return {
      $or: [
        { 'profile.name': { $regex: input, $options: 'i' } },
        {
          'profile.email': {
            $regex: input,
            $options: 'i',
          },
        },
      ],
      ...filter,
    }
  },
  resultFieldName: 'getCollaboratorUsers',
})

export const MembersSelect = ({ filter, dataLoadOptions: _dataLoadOptions, ...props }: UserSelectProps) => {
  return (
    <UserSelect
      filter={filter}
      dataLoadOptions={getCollaboratorUsersDataLoadOptions(filter)}
      {...{
        ...props,
        isMulti: true,
        cacheOptions: false,
        placeholder: 'Search user',
      }}
    />
  )
}
